import videojs from 'video.js';

const Component = videojs.getComponent('Component');

// Default options for the plugin.
const defaults = {
	content: () => 'Info content',
	onShow: () => {},
	onHide: () => {},
	closeBySwipe: false
};

const isSupportTouchEvents = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

class AsideContainer extends Component {
	constructor(player, options) {
		super(player, videojs.mergeOptions(defaults, options));

		this.hide();

		if (this.options_.closeBySwipe && isSupportTouchEvents) {
			this.addClass('vjs-aside-container_swipe-away-on-mobile');
		}

		this.setListeners();
	}

	setListeners() {
		const closeEl = this.$('.vjs-aside-container__close');

		// Закрытие кликом
		this.on(closeEl, 'click', () => {
			if (this.checkEnabledSwipe()) return;
			this.hide();
		});

		// Закрытие свайпом вниз
		let touchStartCoordinate;
		this.on(closeEl, 'touchstart', (event) => {
			const isDisabledSwipe = !this.checkEnabledSwipe();
 			if (isDisabledSwipe) return;
			touchStartCoordinate = event.changedTouches[0].clientY;
		});
		this.on(closeEl, 'touchmove', (event) => {
			const isDisabledSwipe = !this.checkEnabledSwipe();
 			if (isDisabledSwipe) return;
			this.el().style.setProperty('--indent-top', 40 + event.changedTouches[0].clientY - touchStartCoordinate + 'px');
		});
		this.on(closeEl, 'touchend', (event) => {
			const isDisabledSwipe = !this.checkEnabledSwipe();
 			if (isDisabledSwipe) return;
			if (event.changedTouches[0].clientY - touchStartCoordinate > 150) {
				this.hide();
			}
			this.el().style.setProperty('--indent-top', '40px');
		});

		this.player().on('playerresize', () => {
			if (this.player().currentWidth() < this.options_.fullHeightBreakpoint) {
				this.addClass('vjs-aside-container_full-height');
				if (this.player().hasClass('vjs-multicam_show')) {
					this.player().multicam().close();
				}
			} else {
				this.removeClass('vjs-aside-container_full-height');
			}
		});
	}

	checkEnabledSwipe() {
		const isMobile = this.player().getAttribute('data-css-breakpoint') === this.options_.mobileBreakpoint;
		return this.options_.closeBySwipe && isSupportTouchEvents && isMobile;
	}

	show() {
		setTimeout(() => {
			super.show();
		}, window.debug_timeout || 100);
		this.options_.show(this.$('.vjs-aside-container__content'));
		this.trigger('AsideContainer/show');
	}

	hide() {
		super.hide();
		this.options_.onHide(this.$('.vjs-aside-container__content'));
		this.trigger('AsideContainer/hide');
	}

	isHidden() {
		return this.hasClass('vjs-hidden');
	}

	createEl() {
		const el = videojs.createEl('div', {
			className: 'vjs-aside-container',
		});
		el.innerHTML = this.getInnerHtml();
		return el;
	}

	getInnerHtml() {
		return `
			<div class="vjs-aside-container__close">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M6 6L11.2929 11.2929C11.6834 11.6834 11.6834 12.3166 11.2929 12.7071L6 18" stroke="#737373" stroke-width="2" stroke-linecap="round"/>
					<path d="M18 6L12.7071 11.2929C12.3166 11.6834 12.3166 12.3166 12.7071 12.7071L18 18" stroke="#737373" stroke-width="2" stroke-linecap="round"/>
				</svg>
				<span></span>
			</div>
			<div class="vjs-aside-container__content"></div>
		`;
	}
}

Component.registerComponent('AsideContainer', AsideContainer);
export default AsideContainer;
